module.exports = __webpack_public_path__ + "img/Vectorinfo.0012194e.svg";